<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 text-center">
        {{ year }}
        &copy; All Rights Reserved
      </div>
    </div>
  </div>
</footer>
